import { Component, OnInit, Input, ViewChild, OnDestroy, AfterViewInit, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ContentfulService } from '../../_services/contentful.service';
import { Observable, from, of, mergeMap, tap, defer } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Asset, Entry } from 'contentful';
import { environment } from '../../../enviroments/environment';
import { NgZone } from '@angular/core';
import { LandingPage } from '../../_models/landing-page.model';
import { FormFlow } from '../../_models/form-dynamic.model';
import { Theme } from '../../_models/theme.model';
import { Branding } from '../../_models/branding.model'; 
import { LinkingBetweenComponentsService } from '../../_services/linking-between-components.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { FormDataService } from '../../_services/form-data.service';
import { FormSubmissionService } from '../../_services/form-submission.service';
import { JornayaService } from '../../_services/jornaya.service';
import { ScriptsInjectorService } from '../../_services/scripts-injector.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ImageLink } from '../../_models/imageLink.model';
import { SecureLink } from '../../_models/footer.model';
import { Icon } from '../../_models/icon.model'; 
import { TagsInjector } from '../../_models/tagsInjector.model';
import { TagsInjectorService } from '../../_services/tags-injector.service';
import { TypeScriptValidations } from '../../_models/typescript-validations';
import {TypescriptValidationsService} from '../../_services/typescript-validations.service'
import { WindowService } from '../../_services/window.service';
import { TelemetryService } from '../../_services/telemetry.service';
import { TelemetryContextService } from '../../_services/telemetry-context.service';
import { TelemetryTransitionContextService, TelemetryTransitionSource } from '../../_services/telemetry-transition-context.service';
import { VirtualPageViewService } from '../../_services/virtual-page-view.service';
import { LandingApiProgressService } from '../../_services/landing-api-progress.service';

@Component({
  selector: 'app-form-dynamic-v1',
  standalone: false,
  templateUrl: './form-dynamic-v1.component.html',
  styleUrl: './form-dynamic-v1.component.css',
  animations: [
    trigger('stepAnimation', [
      transition(':increment', [
        style({ opacity: 0, transform: 'translateX(100px)' }),
        animate('300ms ease-out', 
        style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':decrement', [
        style({ opacity: 0, transform: 'translateX(-100px)' }),
        animate('300ms ease-out',   
        style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
    ]),
  ],
})
export class FormDynamicComponentV1 implements OnInit, OnDestroy {
  @ViewChild('dynamicForm', { static: false }) formRef!: ElementRef;
  @Input() formFlow: Entry<FormFlow> | undefined;
  @Input() themeContent: Entry<Theme> | undefined;
  @Input() landingTitle: string = '';

  isBrowser: boolean;

  currentStep = 0;
  entryText: string = '';
  backgroundMedia!: Array<Asset>;
  branding!: Entry<Branding>;
  brandingImage!: Entry<ImageLink>;
  brandIcon!: Entry<Icon>;
  formData: { [key: string]: any } = {};
  tagsInjector!: Array<Entry<TagsInjector>>;
  typeScriptValidations!: Array<Entry<TypeScriptValidations>>;
  hideProgress: boolean = false;
  hideNextButton: boolean = false;
  
  
  hideNextButtonDynamic!: boolean;
  hideNextButtonDynamicFieldKey!: string;
  hideNextButtonDynamicFieldValue! : any;

  steps: any[] = [];
  isLoading = true;

  environment = environment;
  successMessage: string = '';
  errorMessage: string = '';

  isSubmitting = false;
  isSaving = false;
  showResults = false;

  entryId = 'TU_ENTRY_ID';
  inspectorTags!: string;
  private subscription!: () => void;
  // Telemetry: track first view per step index.
  private stepFirstViewTracked = new Set<number>();
  // Telemetry: buffer current step events received before step metadata is ready.
  private pendingStepForTelemetry: number | null = null;
  private stepEnteredAt = Date.now();
  private jornayaDebugEnabled = false;
  private jornayaDebugStartedAt = 0;
  private jornayaLeadIdLastValue = '';
  private jornayaDebugIntervalId: number | null = null;
  private jornayaMutationObserver: MutationObserver | null = null;


  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private contentful: ContentfulService,
    private linkComponent: LinkingBetweenComponentsService,
    private route: ActivatedRoute,
    private router: Router,
    private formDataService: FormDataService,
    private submissionService: FormSubmissionService,
    private jornayaService: JornayaService,
    private scriptsInjectorService: ScriptsInjectorService,
    private tagsInjectorService: TagsInjectorService,
    private sanitizer: DomSanitizer,
    private typescriptValidationsService: TypescriptValidationsService,
    private ngZone: NgZone,
    private formSubmissionService: FormSubmissionService,
    private landingApiProgressService: LandingApiProgressService,
    private window: WindowService,
    private telemetryService: TelemetryService,
    private telemetryContextService: TelemetryContextService,
    private telemetryTransitionContext: TelemetryTransitionContextService,
    private virtualPageViewService: VirtualPageViewService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  private get storage(): Storage | null {
    return this.window.window?.localStorage ?? null;
  }

  // private get isBrowser(): boolean {
  //   return !!this.window.window;
  // }


  async ngOnInit() {
    const urlParams = new URLSearchParams(this.window.locationSearch);
    const urlTelemetryContext = this.telemetryContextService.getUrlTelemetryContext(urlParams);
    let genericGuid: string | null = null;
    //genericGuid = localStorage.getItem('Session-Guid'); //JLFranco
    genericGuid = this.storage?.getItem('Session-Guid') ?? null;

    if(genericGuid == null){ 
        genericGuid = this.generateGuid();
        //localStorage.setItem('Session-Guid', genericGuid); //JLFranco
        this.storage?.setItem('Session-Guid', genericGuid);
    } else {
        //genericGuid = localStorage.getItem('Session-Guid'); //JLFranco
        genericGuid = this.storage?.getItem('Session-Guid') ?? null;
    }
    
    const uniqueIndentifier = genericGuid;
    const urlIdentifier = urlTelemetryContext.landingPageId + '_' + uniqueIndentifier;

    // Telemetry: initialize shared context for form journey events.
    this.telemetryService.setCommonContext({
      landingSourceType: 'contentful',
      sessionGuid: uniqueIndentifier,
      appEnv: environment.production ? 'prod' : 'dev',
      ...urlTelemetryContext,
    });
    // Telemetry VP: initialize independent virtual page context.
    this.virtualPageViewService.setCommonContext({
      landingSourceType: 'contentful',
      landingTitle: this.landingTitle,
      sessionGuid: uniqueIndentifier,
      appEnv: environment.production ? 'prod' : 'dev',
      ...urlTelemetryContext,
    });


    this.initializeJornayaDebug();
    this.logJornayaSnapshot('ngOnInit:start');

    if (urlIdentifier) {
      this.formDataService.updateIdentifier(urlIdentifier);
    }
    this.formDataService.formData$.subscribe(data => {
      this.formData = data;
      this.loadHideNextButtonDynamic(this.steps[this.currentStep]);

    });

    this.formDataService.currentStep$.subscribe(step => {
      const previousStep = this.currentStep;
      this.currentStep = step;
      this.handleCurrentStepChange(step, previousStep);
    });

    this.linkComponent.getTrigger().subscribe(() => {
      this.nextStep();
    });

    this.logJornayaDebug('loadFormFlow:before');
    this.loadFormFlow();
    this.logJornayaSnapshot('loadFormFlow:after');
    //this.activeSlide(); //JLFranco
    if (this.isBrowser) {
      this.activeSlide();
    }

    // this.scriptsInjectorService.initializeGTM(
    //   'GTM-KCMVZ6',  // ID de GTM
    //   '42993',       // ID de cuenta
    //   '18951'        // ID de contenedor
    // );

    // this.scriptsInjectorService.initializeGTM(
    //   'GTM-5PCK6WGC',     // gtmId
    //   '42993',            // accountId
    //   '18951',            // containerId
    //   'Get Your Quote',   // businessName
    //   'MORTGAGE'          // templateName
    // );

    // this.scriptsInjectorService.initializeJornaya('39cf3e4a-3398-c8d1-7be0-2b0f9c333374', 'B4136BF0-2BCE-FBC8-2E97-6D2D22F3CF46');
    this.scriptsInjectorService.initializeTrustedForm();

      const thankYouPageMode = urlParams.get('ThankYouPageMode') || urlParams.get('thankYouPageMode');
      const thanksSubId = urlParams.get('ThanksSubID');

    
      
      if(thankYouPageMode === '1') {
        this.formSubmissionService.handleSubmissionResponse('null', { ThanksSubID: thanksSubId , ThankYouPageMode: thankYouPageMode });
      }

  }

  ngOnDestroy(): void {
    if (this.jornayaDebugIntervalId !== null && this.window.window) {
      this.window.window.clearInterval(this.jornayaDebugIntervalId);
      this.jornayaDebugIntervalId = null;
    }

    this.jornayaMutationObserver?.disconnect();
    this.jornayaMutationObserver = null;

    this.subscription?.();
  }

  private handleLiveUpdate(fields: any) {
    this.formData = { ...this.formData, ...fields };
  }

  private loadFormFlow() {
    this.steps = this.formFlow?.fields?.stepsform as unknown as [];
    this.entryText = this.formFlow?.fields.entryText as unknown as string;
    this.backgroundMedia = this.formFlow?.fields.backgroundMedia as unknown as Array<Asset>;
    this.branding = this.formFlow?.fields?.branding as unknown as Entry<Branding>;
    
    this.brandingImage = this.branding?.fields?.image as unknown as Entry<ImageLink>;
    this.brandIcon = this.branding?.fields?.icon as unknown as Entry<Icon>;
    this.tagsInjector = this.formFlow?.fields?.tagsInjector as unknown as Array<Entry<TagsInjector>>;
    this.typeScriptValidations = this.formFlow?.fields?.typeScriptValidations as unknown as Array<Entry<TypeScriptValidations>>;

    const formFlowAny = this.formFlow as any;
    // Telemetry: enrich context with Contentful metadata and emit form_loaded.
    this.telemetryService.setCommonContext({
      formFlowId: formFlowAny?.sys?.id,
      titleMain: formFlowAny?.fields?.titlemain,
      contentfulEnvironment: formFlowAny?.sys?.environment?.sys?.id,
      publishedVersion: formFlowAny?.sys?.publishedVersion,
      version: formFlowAny?.sys?.version,
    });
    // Telemetry VP: enrich virtual page context with Contentful form metadata.
    this.virtualPageViewService.setCommonContext({
      formFlowId: formFlowAny?.sys?.id,
      titleMain: formFlowAny?.fields?.titlemain,
      contentfulEnvironment: formFlowAny?.sys?.environment?.sys?.id,
      publishedVersion: formFlowAny?.sys?.publishedVersion,
      version: formFlowAny?.sys?.version,
    });
    this.telemetryService.trackEvent('form_loaded', {
      totalSteps: this.steps.length,
      formFlowId: formFlowAny?.sys?.id,
      titleMain: formFlowAny?.fields?.titlemain,
    });

    this.hideProgress = this.steps[this.currentStep]?.fields?.configuration?.hideProgress || false;
    this.hideNextButton = this.steps[this.currentStep]?.fields?.configuration?.hideNextButton || false;
    
    this.hideNextButtonDynamic = this.steps[this.currentStep]?.fields?.configuration?.hideNextButtonDynamic || false;
    this.hideNextButtonDynamicFieldKey = this.steps[this.currentStep]?.fields?.configuration?.hideNextButtonDynamicFieldKey || "";
    this.hideNextButtonDynamicFieldValue = this.steps[this.currentStep]?.fields?.configuration?.hideNextButtonDynamicFieldValue || "";
    
    this.loadHideNextButtonDynamic(this.steps[this.currentStep]);
    

     if(this.tagsInjector) {
      var tags = Array.from(this.tagsInjector);
      this.logJornayaDebug('tagsInjector:processing', {
        tagsCount: tags.length,
      });
      tags.forEach(tag => {
        var config: any;
        config = tag.fields.configuration;
        if(Array.isArray(config)) {
          config.forEach((scriptConfig: any) => {
            if (this.isJornayaScriptConfig(scriptConfig)) {
              this.logJornayaDebug('tagsInjector:jornaya-script-config-detected', {
                src: scriptConfig?.src || '',
                hasContent: !!scriptConfig?.content,
              });
            }
            this.tagsInjectorService.injectScript(scriptConfig);
          });
        }
      });

     }

     this.logJornayaSnapshot('loadFormFlow:after-tagsInjector');

     if(this.typeScriptValidations) {
      this.typescriptValidationsService.saveCachedFormBrandSettings(this.typeScriptValidations)
     }

    this.flushPendingStepTelemetry();

    this.isLoading = false;
    this.initializeFormData();
    this.preLoadAssest(this.steps);
  }

  // Telemetry: avoid losing initial step events while waiting for async step config.
  private handleCurrentStepChange(step: number, previousStep: number): void {
    if (!this.steps?.length) {
      this.pendingStepForTelemetry = step;
      return;
    }

    this.trackStepViewed(step, previousStep);
  }

  // Telemetry: flush buffered step event once Contentful step metadata is available.
  private flushPendingStepTelemetry(): void {
    if (!this.steps?.length) {
      return;
    }

    if (this.pendingStepForTelemetry !== null) {
      const pendingStep = this.pendingStepForTelemetry;
      this.pendingStepForTelemetry = null;
      this.trackStepViewed(pendingStep, -1);
      return;
    }

    if (!this.stepFirstViewTracked.has(this.currentStep)) {
      this.trackStepViewed(this.currentStep, -1);
    }
  }
  private initializeFormData() {
    this.steps.forEach(step => {
      const fields = step?.fields?.configuration?.fields || [];
      fields.forEach((field: any) => {
        
        if (!this.formData.hasOwnProperty(field.key)) {
          if (field.type === '_checkbox_options') {
            this.formData[field.key] = [];
          } else if (field.type === 'checkbox_options') {
            this.formData[field.key] = Array.isArray(this.formData[field.key]) ? this.formData[field.key] : [];
          } else if (step.fields.stepType === 'slider_input') {            
            this.formData[field.key] = field.defaultValue ?? 0;
            
          } else if (field.fieldType === 'dropdown') {
            this.formData[field.key] = null;
          } else if (step.fields.stepType === 'single_option_conditional') {
            const fields = step.fields.configuration.fields;
            const conditionalField = fields.find((f: any) => f.conditional);
            const parentField = fields.find((f: any) => !f.conditional);

            if (this.formData[parentField.key] !== conditionalField.conditionalValue) {
              this.formData[conditionalField.key] = null;
            }
          } else if(step.fields.stepType === 'single_option_icon') {

            if(step.fields.configuration.fields.length > 0) {
              var fields = step.fields.configuration.fields
              
              for (let i = 0; i < fields.length; i++) {
                const configuration = fields[i];
                for (let ii = 0; ii < configuration.options.length; ii++) {
                  const options = configuration.options[ii];
                  if(options.valueType != null && options.valueType != "") {
                    if(options.valueType == "Bool") {
                      options.value = Boolean(options.value)
                    }
                  }

                }
              }

            }

          }
          else {
            this.formData[field.key] = '';
          }

        }
      });

    });

  }
 
  saveToLocalStorage() {
    this.steps.forEach(step => {
      const fields = step?.fields?.configuration?.fields || [];
      fields.forEach((field: any) => {
        if (field.type === 'checkbox_options' && !Array.isArray(this.formData[field.key])) {
          this.formData[field.key] = [];
        }
      });
    });

  }

  async submitForm() {
    this.isSaving = true;
    this.logJornayaSnapshot('submit:precheck');
    // Telemetry: submit action and total submit duration.
    const submitTimer = this.telemetryService.startTimer();
    const submitStep = this.getStepTelemetry(this.currentStep);
    this.telemetryService.trackEvent('SUBMIT-Click', {
      stepIndex: this.currentStep,
      stepId: submitStep.stepId,
      stepType: submitStep.stepType,
      stepTitle: submitStep.stepTitle,
    });

    try {
      await this.submissionService.submitForm(this.window.locationOrigin + this.window.locationPathname);
      this.telemetryService.trackEvent('form_submit_result', {
        success: true,
      }, {
        durationMs: this.telemetryService.stopTimer(submitTimer),
      });
    } catch (error) {
      this.telemetryService.trackEvent('form_submit_result', {
        success: false,
        errorType: (error as any)?.name || 'submit_error',
        errorCode: (error as any)?.status || '',
      }, {
        durationMs: this.telemetryService.stopTimer(submitTimer),
      });

    } finally {
      this.isSaving = false;
    }
  }

  isStepValid(): boolean {
    const currentStepConfig = this.steps[this.currentStep]?.fields?.configuration?.fields || [];
    return currentStepConfig.every((field: any) => {
      const value = this.formData[field.key];

      if (field.validations?.required && (value === '' || value == null || (Array.isArray(value) && value.length === 0))) {        
        return false;
      } else if(field.validations?.required && (value !== '' || value !== null)) {
        if(![null, '', undefined].includes(field.validations?.requiredValue)) {
          if(field.validations?.requiredValue === value) {
            return true;
          } else {
           return false; 
          } 
        } else if(field.validations?.format) {
          if(field.type === 'email_input') {
            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;   
            if (!emailPattern.test(value)) {
              return false;
            }  else {
                return true;
              }
          } else if(field.type === 'phone_input') {
            
              const phoneLength = 10;
              if(!(value.length === phoneLength)) {
                return false;            
              } else {
                return true;
              }
          } else if(field.type === 'zip_code') {
              const phoneLength = 5;

              if(!(value.length === phoneLength)) {
                return false;            
              } else if(this.formData['City'] == null || this.formData['State'] == null) {
                return false;
              } else {
                return true;
              }
          } else {          
            return true;
          }      
        } else {
          return true;
        }

      } else if(field.validations?.format) {
        if(field.type === 'email_input') {
          const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;   
          if (!emailPattern.test(value)) {
            return false;
          }  else {
              return true;
            }
        } else if(field.type === 'phone_input') {
          
            const phoneLength = 10;
            if(!(value.length === phoneLength)) {
              return false;            
            } else {
              return true;
            }
        } else if(field.type === 'zip_code') {
            const phoneLength = 5;

            if(!(value.length === phoneLength)) {
              return false;            
            } else if(this.formData['City'] == null || this.formData['State'] == null) {
              return false;
            } else {
              return true;
            }
        } else {          
          return true;
        }      
      } else {
        return field.validations?.required ? value != null : true;
      }
      
    });
  }

  private convertUrlParamsToCorrectTypes() {
    this.steps.forEach(step => {
      const fields = step?.fields?.configuration?.fields || [];
      fields.forEach((field: any) => {
        const value = this.formData[field.key];

        if (step.fields.stepType === 'slider_input') {
          this.formData[field.key] = Number(value) || field.defaultValue;
        }

        if (field.type === 'checkbox_options' && typeof value === 'string') {
          this.formData[field.key] = value.split(','); // Ej: "val1,val2" → ["val1", "val2"]
        }
      });
    });
  }
  activeSlide() {
    if (!this.isBrowser) return;

    //const slides = document.querySelectorAll('.slide'); //JLFranco
    const slides = this.window.document?.querySelectorAll('.slide') ?? [];
    let currentSlide = 0;    
    function nextSlide() {
        if(slides && slides.length == 0) {        
          slides[currentSlide].classList.remove('active');
          currentSlide = (currentSlide + 1) % slides.length;
          slides[currentSlide].classList.add('active');
        }
      setInterval(nextSlide, 5000);
     }


  }
  loadProgressBar(currentStep: number, totalSteps: number) {
    if (!this.isBrowser) return;

    var progressBar = this.window.document?.querySelector(".dynamic-progress-bar") as HTMLElement;
    var _currentStep = (currentStep + 1)

    progressBar?.style.setProperty("--progress", `${(_currentStep / totalSteps) * 100}%`);
  }
  
  loadHideNextButtonDynamic(currentStep: any) {
    this.hideNextButtonDynamic = this.steps[this.currentStep]?.fields?.configuration?.hideNextButtonDynamic || false;
    this.hideNextButtonDynamicFieldKey = this.steps[this.currentStep]?.fields?.configuration?.hideNextButtonDynamicFieldKey || "";
    this.hideNextButtonDynamicFieldValue = this.steps[this.currentStep]?.fields?.configuration?.hideNextButtonDynamicFieldValue || "";

    if(this.hideNextButtonDynamic && this.hideNextButtonDynamicFieldKey != "" && this.hideNextButtonDynamicFieldValue != "") {
        if(this.formData[this.hideNextButtonDynamicFieldKey] == this.hideNextButtonDynamicFieldValue) {
          this.hideNextButton = false;
        } else {
          this.hideNextButton = true;
        } 

     }
  }

  getSafeImageUrl(imglink?: Entry<ImageLink>): SafeUrl {
    if (!imglink?.fields?.backGroundImageUrl?.['fields']?.['file']?.['url']) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(''); 
    }
    
    const url = `https:${imglink.fields.backGroundImageUrl?.['fields']?.['file']?.['url']}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }    


  __getSafeAssetUrl(asset?: Asset ): SafeUrl {
    var assetURL = asset?.fields.file?.url
    if (!assetURL) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(''); 
    }
    
    return `https:${assetURL}`;
  }

  getSafeAssetUrl(asset?: Asset): SafeUrl {
    const assetURL = asset?.fields.file?.url;
    const urlString = typeof assetURL === 'string' ? assetURL : (assetURL as { url?: string })?.url;
    if (!urlString) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('');
    }
    
    const fullUrl = urlString.startsWith('//') ? `https:${urlString}` : urlString;    
    return fullUrl;
  }
  

  openSecureWindow(link?: Entry<ImageLink>) {
    if (!link?.fields) return;

    const url = link.fields.linkUrl as unknown as string;
    const clickActionType = link.fields.clickActionType as unknown as string;

    if (clickActionType === 'Open New Tab') {
      if (url) {
        window.open(url, '_blank')?.focus();
      }
      
    } else {
      const features = `
        width=${link.fields.windowWidth},
        height=${link.fields.windowHeight},
        scrollbars=${link.fields.scrollbarsEnabled ? 'yes' : 'no'}
      `;
      if(url) {
        window.open(url, '', features)?.focus();
      }
    }
  }  

  generateGuid(): string {
    return crypto.randomUUID();
  }  


  validateConditionalFieldValue(move:string): boolean {
    var newStep = 0;
    if(move === 'next') {
      newStep = this.currentStep + 1

    } else if(move === 'prev') {
      newStep = this.currentStep - 1
    }

    if (!this.steps || !this.steps[newStep]?.fields?.configuration?.fields) {
      return true;
    }

    const fields = this.steps[newStep].fields.configuration.fields;

    for (const field of fields) {
      if (field.validations) {
        const validations = field.validations;
        
        if(validations?.conditionalIntruction == 'skipStep') {
          if (validations?.conditionalKey !== null && validations?.conditionalValue !== null) {
  
            const conditionalFieldKey = validations.conditionalKey;            
            const conditionalFieldValue = validations.conditionalValue;
            const conditionalOperator = validations.conditionalOperator || '==';
            
            const currentConditionalValue = this.formData[conditionalFieldKey];
            
            const conditionMet = this.evaluateCondition(
              conditionalFieldValue,
              conditionalOperator, 
              currentConditionalValue
            );
                       
            if (!conditionMet) {
              return false;
            }
          }
        }

      }
    }
    return true;
  }


  private evaluateCondition(value: any, operator: string = '==', target: any): boolean {
    switch (operator) {
      case '>':
        return Number(target) > Number(value);
      case '>=':
        return Number(target) >= Number(value);
      case '<':
        return Number(target) < Number(value);
      case '<=':
        return Number(target) <= Number(value);
      case '=':
        return target == value;
      case '==':
        return target == value;
      case '===':
        return target === value;
      case '!=':
        return target != value;
      case '!==':
        return target !== value;
      case 'includes':
        return String(target).includes(String(value));
      case 'startsWith':
        return String(target).startsWith(String(value));
      case 'endsWith':
        return String(target).endsWith(String(value));
      default:
        return false;
    }
  }

  calculateDynamicValues() {
    var fieldConditional;
    var conditionalKey;
    var conditionalValue;
    this.steps.forEach(step => {
      step.fields.configuration.fields.forEach((field: any) => {
        var fieldValidations = field.validations;
  
        conditionalKey = fieldValidations?.conditionalKey ? fieldValidations?.conditionalKey : null;
        if(conditionalKey !== undefined && conditionalKey !== null) {
  
          switch(fieldValidations?.conditionalOperator) {
            case '=':
              if(this.formData[conditionalKey] === fieldValidations?.conditionalValue) {
                fieldConditional = true;
              }
            break;
            case '>':
              if(this.formData[conditionalKey] > fieldValidations?.conditionalValue) {
                fieldConditional = true;
              }
              break;
  
          }
  
        }
      });
    });

    var sliderTouchedString = this.storage?.getItem('sliderTouched') || '{}';
    var sliderTouched = JSON.parse(sliderTouchedString);


    // console.log('sliderTouched:', sliderTouched);

    var cso = ((this.formData['EstimatedHomeValue'] || 0) * 0.9) - 10000 - (this.formData['LoanAmount'] || 0);
    cso = Math.round(cso / 1000) * 1000;
    
    if(sliderTouched['CashOut'] != true) {
      if(cso < 0) {
        cso = 0;
        this.formData['CashOut'] = 0;
      } else {
        this.formData['CashOut'] = cso; 
      }

      if(conditionalKey !== undefined && conditionalKey !== null) {
        if(!fieldConditional) {
          cso = 0;
          this.formData['CashOut'] = 0; 
        }
      }

    } else {
      if(this.formData['CashOut'] > cso) {
        if(cso < 0) {
          cso = 0;
          this.formData['CashOut'] = 0;
        } else {
          this.formData['CashOut'] = cso; 
        }
  
        if(conditionalKey !== undefined && conditionalKey !== null) {
          if(!fieldConditional) {
            cso = 0;
            this.formData['CashOut'] = 0; 
          }
        }
      } else if(this.formData['CashOut'] == 0 && cso == 0) {
        this.formData['CashOut'] = 0;
      } else if(cso > 0) {
        // this.formData['CashOut'] = cso;
      }
      
      if(conditionalKey !== undefined && conditionalKey !== null) {
        if(!fieldConditional) {
          cso = 0;
          this.formData['CashOut'] = 0; 
        }
      }

    }
  }

  validateConditionalFieldValueForStep(move: string, targetStep: number): boolean {
    const newStep = targetStep;
    if (!this.steps || !this.steps[newStep]?.fields?.configuration?.fields) {
      return true;
    }

    const fields = this.steps[newStep].fields.configuration.fields;
    for (const field of fields) {
      if (field.validations) {
        const validations = field.validations;
        if (validations?.conditionalIntruction == 'skipStep') {
          if (validations?.conditionalKey !== null && validations?.conditionalValue !== null) {
            const conditionalFieldKey = validations.conditionalKey;
            const conditionalFieldValue = validations.conditionalValue;
            const conditionalOperator = validations.conditionalOperator || '==';
            
            const currentConditionalValue = this.formData[conditionalFieldKey];
            
            const conditionMet = this.evaluateCondition(
              conditionalFieldValue,
              conditionalOperator, 
              currentConditionalValue
            );
              
            

            if (!conditionMet) {

              return false;
            }
          }
        }
      }
    }
    return true;
  }  

  async nextStep(): Promise<void> {
    const timeOnStepMs = this.getTimeOnCurrentStepMs();
    const currentStepTelemetry = this.getStepTelemetry(this.currentStep);
    const fromStepValueSnapshot = this.getStepValueSnapshot(this.currentStep);
    const maxAttempts = this.steps.length;
    let attempt = 1;
    let validationPassed = false;
    let testStep = this.currentStep + 1;
    this.calculateDynamicValues();
    while (attempt <= maxAttempts && !validationPassed) {

      this.calculateDynamicValues();
      
      const validationResult = this.validateConditionalFieldValueForStep('next', testStep);
      
      if (validationResult === true) {
        validationPassed = true;
      } else {
        testStep++;
        attempt++;
        
        if (attempt <= maxAttempts) {
          await this.delay(10);
        }
      }
    }
    this.calculateDynamicValues();

    const finalStep = validationPassed ? testStep : testStep - 1;
    
    if (!validationPassed) {
    }

    // Telemetry: semantic step transition event with source and skip semantics.
    const transitionContext = this.telemetryTransitionContext.consumePending();
    const computedSource = this.resolveTransitionSource(finalStep, 'forward', transitionContext?.source);
    if (computedSource === 'next_button') {
      this.telemetryService.trackEvent('form_step_next_clicked', {
        fromStepIndex: this.currentStep,
        fromStepId: currentStepTelemetry.stepId,
        fromStepTitle: currentStepTelemetry.stepTitle,
        fromStepType: currentStepTelemetry.stepType,
        toStepIndex: finalStep,
        toStepId: this.getStepTelemetry(finalStep).stepId,
        toStepTitle: this.getStepTelemetry(finalStep).stepTitle,
        isStepValid: this.isStepValid(),
      });
    }

    this.telemetryService.trackEvent('form_step_transition', {
      fromStepIndex: this.currentStep,
      fromStepId: currentStepTelemetry.stepId,
      fromStepTitle: currentStepTelemetry.stepTitle,
      fromStepType: currentStepTelemetry.stepType,
      toStepIndex: finalStep,
      toStepId: this.getStepTelemetry(finalStep).stepId,
      toStepTitle: this.getStepTelemetry(finalStep).stepTitle,
      toStepType: this.getStepTelemetry(finalStep).stepType,
      direction: 'forward',
      transitionSource: computedSource,
      isSkip: Math.abs(finalStep - this.currentStep) > 1,
      skipReason: Math.abs(finalStep - this.currentStep) > 1 ? 'conditional_rule' : '',
      triggerFieldKey: transitionContext?.triggerFieldKey || '',
      timeOnStepMs,
      ...fromStepValueSnapshot,
    });
    this.finalizeStepChange(finalStep);
  }

  async prevStep(): Promise<void> {
    const timeOnStepMs = this.getTimeOnCurrentStepMs();
    const currentStepTelemetry = this.getStepTelemetry(this.currentStep);
    const fromStepValueSnapshot = this.getStepValueSnapshot(this.currentStep);
    const maxAttempts = 15;
    let attempt = 1;
    let validationPassed = false;
    let testStep = this.currentStep - 1;

    while (attempt <= maxAttempts && !validationPassed) {
      
      this.calculateDynamicValues();
      
      const validationResult = this.validateConditionalFieldValueForStep('prev', testStep);
      
      if (validationResult === true) {
        validationPassed = true;
      } else {        
        testStep--;
        attempt++;
        
        if (attempt <= maxAttempts) {
          await this.delay(10);
        }
      }
    }

    const finalStep = validationPassed ? testStep : testStep + 1;
    
    if (!validationPassed) {
    }

    this.telemetryService.trackEvent('form_step_back_clicked', {
      fromStepIndex: this.currentStep,
      fromStepId: currentStepTelemetry.stepId,
      fromStepTitle: currentStepTelemetry.stepTitle,
      fromStepType: currentStepTelemetry.stepType,
      toStepIndex: finalStep,
      toStepId: this.getStepTelemetry(finalStep).stepId,
      toStepTitle: this.getStepTelemetry(finalStep).stepTitle,
    });

    // Telemetry: semantic back transition event.
    this.telemetryService.trackEvent('form_step_transition', {
      fromStepIndex: this.currentStep,
      fromStepId: currentStepTelemetry.stepId,
      fromStepTitle: currentStepTelemetry.stepTitle,
      fromStepType: currentStepTelemetry.stepType,
      toStepIndex: finalStep,
      toStepId: this.getStepTelemetry(finalStep).stepId,
      toStepTitle: this.getStepTelemetry(finalStep).stepTitle,
      toStepType: this.getStepTelemetry(finalStep).stepType,
      direction: 'back',
      transitionSource: 'unknown',
      isSkip: Math.abs(finalStep - this.currentStep) > 1,
      skipReason: Math.abs(finalStep - this.currentStep) > 1 ? 'conditional_rule' : '',
      triggerFieldKey: '',
      timeOnStepMs,
      ...fromStepValueSnapshot,
    });
    this.finalizeStepChange(finalStep);
  }  

  // Telemetry: resolve source with business-priority rules.
  private resolveTransitionSource(finalStep: number, direction: 'forward' | 'back', pendingSource?: TelemetryTransitionSource): 'next_button' | 'option_auto_advance' | 'conditional_auto_advance' | 'unknown' {
    if (direction === 'back') {
      return 'unknown';
    }

    if (pendingSource === 'option_auto_advance') {
      return 'option_auto_advance';
    }

    if (Math.abs(finalStep - this.currentStep) > 1) {
      return 'conditional_auto_advance';
    }

    if (pendingSource === 'conditional_auto_advance') {
      return 'conditional_auto_advance';
    }

    return 'next_button';
  }

  // Telemetry: track step views and first views.
  private trackStepViewed(stepIndex: number, previousStep: number): void {
    if (!this.steps?.length || stepIndex < 0 || stepIndex >= this.steps.length) {
      return;
    }

    if (stepIndex === previousStep && this.stepFirstViewTracked.has(stepIndex)) {
      return;
    }

    const stepTelemetry = this.getStepTelemetry(stepIndex);
    this.virtualPageViewService.trackFormStepView({
      stepIndex,
      stepId: stepTelemetry.stepId,
      stepType: stepTelemetry.stepType,
      stepTitle: stepTelemetry.stepTitle,
    });

    this.telemetryService.trackEvent('form_step_viewed', {
      stepIndex,
      stepId: stepTelemetry.stepId,
      stepType: stepTelemetry.stepType,
      stepTitle: stepTelemetry.stepTitle,
    });

    if (!this.stepFirstViewTracked.has(stepIndex)) {
      this.stepFirstViewTracked.add(stepIndex);
      this.telemetryService.trackEvent('form_step_first_viewed', {
        stepIndex,
        stepId: stepTelemetry.stepId,
        stepType: stepTelemetry.stepType,
        stepTitle: stepTelemetry.stepTitle,
      });
    }
  }

  // Telemetry: reusable step context mapper.
  private getStepTelemetry(stepIndex: number): { stepId: string; stepType: string; stepTitle: string } {
    const stepAny = this.steps?.[stepIndex] as any;
    return {
      stepId: stepAny?.sys?.id || `idx-${stepIndex}`,
      stepType: stepAny?.fields?.stepType || '',
      // Telemetry: human-readable label for analytics while keeping stepId as source of truth.
      stepTitle: stepAny?.fields?.steptitle || '',
    };
  }

  private finalizeStepChange(newStep: number): void {
    this.formDataService.updateCurrentStep(newStep);
    this.formDataService.updateFormData(this.formData);
    this.stepEnteredAt = Date.now();

    this.hideProgress = this.steps[newStep]?.fields?.configuration?.hideProgress || false;
    this.hideNextButton = this.steps[this.currentStep]?.fields?.configuration?.hideNextButton || false;
    this.loadHideNextButtonDynamic(this.steps[this.currentStep]);    
  }

  private getTimeOnCurrentStepMs(): number {
    return Math.max(0, Date.now() - this.stepEnteredAt);
  }

  private getStepValueSnapshot(stepIndex: number): Record<string, string | number | boolean> {
    const fields = (this.steps?.[stepIndex] as any)?.fields?.configuration?.fields || [];
    const sliderField = fields.find((field: any) => String(field?.type || '').toLowerCase().includes('slider'));
    if (!sliderField?.key) {
      return {};
    }

    const value = this.formData?.[sliderField.key];
    const defaultValue = sliderField.defaultValue;
    const numericValue = Number(value);
    const snapshot: Record<string, string | number | boolean> = {
      fromStepFieldKey: sliderField.key,
      fromStepFieldType: 'slider',
      fromStepValueBucket: this.getNumericBucket(numericValue),
      fromStepValueChanged: defaultValue !== undefined && defaultValue !== null
        ? String(value) !== String(defaultValue)
        : value !== undefined && value !== null && String(value).trim() !== '',
    };

    return snapshot;
  }

  private getNumericBucket(value: number, bucketSize: number = 50000): string {
    if (!Number.isFinite(value)) {
      return 'unknown';
    }

    const lower = Math.floor(value / bucketSize) * bucketSize;
    const upper = lower + bucketSize;
    return `${lower}-${upper}`;
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  //region Jornaya Debugging

  private initializeJornayaDebug(): void {
    this.jornayaDebugEnabled = this.readTruthyQueryFlag('debugJornaya');
    if (!this.jornayaDebugEnabled || !this.isBrowser) {
      return;
    }

    try {
      this.jornayaDebugStartedAt = this.window.window?.performance?.now ? this.window.window.performance.now() : Date.now();
      this.logJornayaDebug('enabled');
      if (this.readTruthyQueryFlag('debugJornayaDom')) {
        this.setupJornayaDebugMutationObserver();
      }
      this.setupJornayaLeadIdWatcher();
    } catch (error) {
      console.error('[JORNAYA-DEBUG] initialize failed', error);
    }
  }

  private setupJornayaLeadIdWatcher(): void {
    if (!this.jornayaDebugEnabled || !this.window.window) {
      return;
    }

    this.jornayaDebugIntervalId = this.window.window.setInterval(() => {
      const leadId = this.getLeadIdValue();
      if (leadId === this.jornayaLeadIdLastValue) {
        return;
      }

      this.jornayaLeadIdLastValue = leadId;
      this.logJornayaDebug('leadid:value-changed', {
        leadIdLen: leadId.length,
        hasValue: leadId.length > 0,
        tokenMasked: this.maskJornayaToken(leadId),
      });

      if (leadId.length > 0) {
        this.landingApiProgressService.onJornayaTokenReady(leadId);
      }
    }, 250);
  }

  private setupJornayaDebugMutationObserver(): void {
    if (!this.jornayaDebugEnabled || !this.window.document) {
      return;
    }

    if (typeof MutationObserver === 'undefined') {
      this.logJornayaDebug('dom:observer-not-supported');
      return;
    }

    const observer = new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach((mutation: MutationRecord) => {
        mutation.addedNodes.forEach((node: Node) => {
          if (node.nodeType !== 1) {
            return;
          }
          const element = node as Element;
          if (!this.isJornayaNode(element)) {
            return;
          }

          this.logJornayaDebug('dom:node-added', this.describeJornayaNode(element));
        });

        mutation.removedNodes.forEach((node: Node) => {
          if (node.nodeType !== 1) {
            return;
          }
          const element = node as Element;
          if (!this.isJornayaNode(element)) {
            return;
          }

          this.logJornayaDebug('dom:node-removed', this.describeJornayaNode(element));
        });
      });
    });

    this.jornayaMutationObserver = observer;

    const body = this.window.document.body;
    const head = this.window.document.head;

    if (body) {
      observer.observe(body, {
        childList: true,
        subtree: false,
      });
    }

    if (head) {
      observer.observe(head, {
        childList: true,
        subtree: false,
      });
    }

    this.logJornayaDebug('dom:observer-attached', {
      observeBody: !!body,
      observeHead: !!head,
      subtree: false,
    });
  }

  private describeJornayaNode(node: Element): Record<string, string | number | boolean> {
    const tagName = node.tagName || '';
    const id = node.getAttribute?.('id') || '';
    const src = (node as HTMLScriptElement).src || node.getAttribute?.('src') || '';
    const name = node.getAttribute?.('name') || '';
    return {
      tagName,
      id,
      src,
      name,
    };
  }

  private isJornayaScriptConfig(scriptConfig: { src?: string; content?: string }): boolean {
    const src = scriptConfig?.src || '';
    const content = scriptConfig?.content || '';
    return src.includes('lidstatic.com/campaign') ||
      src.includes('cloudfront.net/campaign') ||
      content.includes('LeadiDscript_campaign') ||
      content.includes('lidstatic.com/campaign') ||
      content.includes('cloudfront.net/campaign');
  }

  private isJornayaNode(node: Element | null): boolean {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    const id = node.getAttribute?.('id') || '';
    const name = node.getAttribute?.('name') || '';
    const src = (node as HTMLScriptElement).src || node.getAttribute?.('src') || '';

    if (id.includes('LeadiDscript') || id === 'leadid_token') {
      return true;
    }

    if (name === 'universal_leadid') {
      return true;
    }

    return src.includes('/campaign/') && (src.includes('lidstatic.com') || src.includes('cloudfront.net'));
  }

  private getLeadIdValue(): string {
    const input = this.window.document?.querySelector('input[name="universal_leadid"]') as HTMLInputElement | null;
    return (input?.value || '').trim();
  }

  private logJornayaSnapshot(stage: string): void {
    if (!this.jornayaDebugEnabled || !this.isBrowser) {
      return;
    }

    const documentRef = this.window.document;
    const campaignScript = documentRef?.getElementById('LeadiDscript_campaign') as HTMLScriptElement | null;
    const baseScript = documentRef?.getElementById('LeadiDscript');
    const leadIdValue = this.getLeadIdValue();
    const currentStepTelemetry = this.getStepTelemetry(this.currentStep);

    this.logJornayaDebug(stage, {
      hasBaseScriptTag: !!baseScript,
      hasCampaignScriptTag: !!campaignScript,
      campaignSrc: campaignScript?.src || '',
      hasLeadIdInput: !!documentRef?.querySelector('input[name="universal_leadid"]'),
      leadIdLen: leadIdValue.length,
      currentStep: this.currentStep,
      currentStepTitle: currentStepTelemetry.stepTitle,
      currentStepType: currentStepTelemetry.stepType,
    });
  }

  private logJornayaDebug(stage: string, details: Record<string, unknown> = {}): void {
    if (!this.jornayaDebugEnabled) {
      return;
    }

    const now = this.window.window?.performance?.now ? this.window.window.performance.now() : Date.now();
    const elapsedMs = Math.max(0, Math.round(now - this.jornayaDebugStartedAt));
    console.log(`[JORNAYA-DEBUG][+${elapsedMs}ms] stage=${stage}`, details);
  }

  private maskJornayaToken(token: string): string {
    if (!token) {
      return '';
    }

    const normalized = token.trim();
    if (normalized.length <= 8) {
      return `${normalized.slice(0, 2)}...${normalized.slice(-2)}`;
    }

    return `${normalized.slice(0, 6)}-...-${normalized.slice(-2)}`;
  }

  private readTruthyQueryFlag(param: string): boolean {
    const value = new URLSearchParams(this.window.locationSearch).get(param)?.trim().toLowerCase();
    return value === '1' || value === 'true' || value === 'yes';
  }

  //endregion Jornaya Debugging

  async old_preLoadAssest(steps: any[]) {
    steps.forEach((step: any) => {
      if(Array.isArray(step.fields.configuration.fields)) {
        step.fields.configuration.fields.forEach((field: any) => {
          if(field.optionsFileAssetID) {
              this.getContenfulAssetURL(field.optionsFileAssetID).subscribe(url => {
                if (url) {              
                  field.optionsFileAssetURL = url                
                }
            });
          }
          if(Array.isArray(field.options)) {
            field.options.forEach((option: any) => {
              if(option.assetID !== undefined) {
                this.getContenfulAssetURL(option.assetID).subscribe(url => {
                  if (url) {              
                    option.safeUrl = url;
                  }
                });
              }
            })
            
            
          }
        });
      }
    });



  }


  async preLoadAssest(steps: any[]) {
    const assetRequests: any[] = [];

    steps.forEach((step: any) => {
      if (Array.isArray(step.fields.configuration.fields)) {
        step.fields.configuration.fields.forEach((field: any) => {

          if (field.optionsFileAssetID) {
            const request$ = this.getContenfulAssetURL(field.optionsFileAssetID).pipe(
              tap(url => {
                if (url) {
                  this.ngZone.run(() => {
                    field.optionsFileAssetURL = url;
                  });
                }
              })
            );
            assetRequests.push(request$);
          }

          if (Array.isArray(field.options)) {
            field.options.forEach((option: any) => {
              if (option.assetID !== undefined) {
                const request$ = this.getContenfulAssetURL(option.assetID).pipe(
                  tap(url => {
                    if (url) {
                      this.ngZone.run(() => {
                        option.safeUrl = url;
                      });
                    }
                  })
                );
                assetRequests.push(request$);
              }
            });
          }
        });
      }
    });


    this.ngZone.runOutsideAngular(() => {
      from(assetRequests).pipe(
        mergeMap(request => request, 3)
      ).subscribe({
        complete: () => {
          console.log('Todos los assets cargados en segundo plano');

        },
        error: (err) => console.error('Error procesando assets:', err)
      });
    });
  }



  getContenfulAssetURL(id: string | null): Observable<string | null> {
    if (!id) return of(null);
    
    return defer(() => from(this.contentful.getAsset(id))).pipe(
      map((asset: Asset) => {
        const imageURL = asset.fields.file?.url as string;
        return `https:${imageURL}`;
      }),
      catchError((err) => {
        console.error('Error:', err);
        return of(null);
      })
    );
  }





}
